module.exports = __webpack_public_path__ + "img/map1.78c59ba1.png";